import { exchangeContactApi } from "@/core/data/api";

export default async (condition) => {
  return await exchangeContactApi.getExchangeContactListPagination(condition);
};
